import { ContentBlocks } from '@components/content-blocks';
import { Page } from '@components/page';
import { Seo } from '@components/Seo';
import { BlogHero } from '@components/_blog-detail/Hero';
import { BlogDetailIntro } from '@components/_blog-detail/Intro';
import { getDrafts, getSanityClient } from '@lib/sanity/client';
import { useIsMounted } from '@lib/use-is-mounted';
import { GetStaticPaths, GetStaticProps } from 'next';
import React, { FC } from 'react';
import { BlogItem } from '__generated__/sanity';
type BlogDetailProps = {
  content: BlogItem;
};
const BlogDetail: FC<BlogDetailProps> = ({
  content
}) => {
  const isMounted = useIsMounted();
  return <Page>
      <Seo data={content.fields.seo} />
      <div className={fadeIn} data-visible={isMounted ? '' : undefined}>
        {content.fields.hero && <BlogHero {...content.fields.hero} />}
        {content.fields.summary?.author && <BlogDetailIntro {...content.fields.summary} author={(content.fields.summary.author as any)} />}
        <ContentBlocks blocks={content.fields.richContent?.items || []} />
      </div>
    </Page>;
};
const fadeIn = "fe6kc5i";
export const getStaticProps: GetStaticProps<BlogDetailProps> = async ({
  preview,
  params
}) => {
  const sanity = getSanityClient(preview);
  const content = await sanity.fetch(`*[_type == "blogItem" && fields.summary.urlSlug.current == "${params.slug}"] {
    ...,
    "fields": {
      ...fields,
      "summary": { ...fields.summary, "author": fields.summary.author-> }
    }
  }`);
  return {
    props: {
      content: (getDrafts(content, preview)[0] as BlogItem)
    }
  };
};
export const getStaticPaths: GetStaticPaths = async () => {
  let paths = [];
  const sanity = getSanityClient();
  const query = `*[_type == "blogItem"] {
    "urlSlug": fields.summary.urlSlug.current
  }`;
  const blogPages = await sanity.fetch(query);
  blogPages.forEach(item => {
    paths.push({
      params: {
        slug: item.urlSlug
      }
    });
  });
  return {
    paths,
    fallback: false
  };
};
export default BlogDetail;

require("./[slug].linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./[slug].tsx");